import { useEffect } from "react";
import { toast } from "react-toastify";

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../hooks/useAuth";
import { useLocalStorage } from "../hooks/useLocalStorage";

function OAuthVerification() {
  const { handleOAuthCallback } = useAuth();
  // const { setLoading } = useContext(StateContext);
  const [searchParams] = useSearchParams();

  const params = useParams();
  let navigate = useNavigate();

  const [fromLocation, setFromLocation] = useLocalStorage<string | null>(
    "fromLocation",
    null
  );

  useEffect(() => {
    console.log(params);
    if (searchParams.has("code") && params.providerId) {
      console.log("oauth code received, forward to backend");
      const code = searchParams.get("code") || "impossible";
      oAuthVerification(params.providerId, code);
    }
  }, []);

  async function oAuthVerification(provider: string, code: string) {
    try {
      // setLoading(true);
      provider = `${provider}-admin`;
      const tokenResponse = await handleOAuthCallback({ provider, code });
      // setLoading(false);
      if (tokenResponse) {
        if (tokenResponse.userCreation) {
          toast.success("SignUp successful");
          window.gtag("event", "conversion", {
            send_to: "AW-10926362464/oMOtCJ-A7cUDEOCejNoo",
          });
          console.log("Conversion");
        } else {
          toast.success("Login successful");
        }

        if (fromLocation !== null) {
          setFromLocation(null);
          navigate(fromLocation, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } else {
        toast.error("Error on signin");
      }
    } catch (e) {
      if (axios.isAxiosError(e)) {
        if (e.response?.data) {
          toast.error(e.response?.data.errorMessage);
        }
      } else {
        console.log(e);
        toast.error("Something really went wrong!");
      }
      navigate("/login");
    }
  }

  return <></>;
}

export default OAuthVerification;
